
 import { Component, Vue, Inject, Prop, Watch } from 'vue-property-decorator';
  import Util from '@/lib/util';
  import AbpBase from '@/lib/abpbase';
  import * as proxy from '@/lib/service-proxies/service-proxies';
  import AppConsts from '@/lib/appconst';
  import PagedFilterAndSortedRequest from '@/store/entities/page-request';
  import pagelist from '@/components/pagelistcomponent';
  @Component({
    components: {  }
  })
export default class home extends pagelist{
            columns=[
                {
                    title:'通道类型',
                    key:'channelTypeName'
                },{
                    title:'通道编码',
                    key:'channelTypeCode'
                },
                {
                    title:'总单量',
                    key:'totalOrderNum'
                },
                {
                    title:'成功单量',
                    key:'successOrderNum'
                },
                {
                    title:'成交额',
                    key:'successAmount'
                },
                {
                    title:'商户服务费',
                    key:'commission'
                },
                {
                    title:'成功率(%)',
                    key:'successRate'
                }
            ]
            merchant={} as any;
            merchantStatistics={} as any;
            merchantchannel=[];
   async created() {
        new proxy.MerchantClientServiceProxy().getMyInfo().then(x => {
            this.merchant = x;
        })
        this.today(0);
    }
    today(ss)
    {   
        var params = new proxy.MerchantStatisticsPageInputDto();
        var paramstable = new proxy.QueryMerchantChannelTypeStatisticsPageInputDto();
        if(ss == 0)
        {
            params.createTime = new Date(new Date(this.formatDate(new Date(),'yyyy/MM/dd')).getTime());
            params.endTime = new Date(new Date(this.formatDate(new Date(),'yyyy/MM/dd')).getTime() + 86400000);
            new proxy.MerchantClientServiceProxy().queryMerchantStatistics(params).then(x=>{
                if(x && x.length) {
                    this.merchantStatistics = x[0];
                } else {
                    this.merchantStatistics = {}
                }
            })
            paramstable.createTime = new Date(new Date(this.formatDate(new Date(),'yyyy/MM/dd')).getTime());
            paramstable.endTime = new Date(new Date(this.formatDate(new Date(),'yyyy/MM/dd')).getTime() + 86400000);
            new proxy.MerchantClientServiceProxy().queryMerchantChannelTypeStatistics(paramstable).then(x=>{
                this.merchantchannel=x;
            })
        }else{
            params.createTime = new Date(new Date(this.formatDate(new Date(),'yyyy/MM/dd')).getTime() - 86400000);
            params.endTime = new Date(new Date(this.formatDate(new Date(),'yyyy/MM/dd')).getTime());
            new proxy.MerchantClientServiceProxy().queryMerchantStatistics(params).then(x=>{
                if(x && x.length) {
                    this.merchantStatistics = x[0];
                } else {
                    this.merchantStatistics = {}
                }
            }) 
            paramstable.createTime = new Date(new Date(this.formatDate(new Date(),'yyyy/MM/dd')).getTime() - 86400000);
            paramstable.endTime = new Date(new Date(this.formatDate(new Date(),'yyyy/MM/dd')).getTime());
            new proxy.MerchantClientServiceProxy().queryMerchantChannelTypeStatistics(paramstable).then(x=>{
                this.merchantchannel=x;
            })

        }
    }

}
